import Vue from 'vue';
import Vuex from 'vuex';
import layout from './layout';
import application from './application';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    layout,
    application,
  },
});
